import React from 'react';

/*
* This is the Tooltip atom
 */

export default function M3_A_Tooltip({children}) {

    return children;
}